export interface DeviceImageConfig {
  [key: string]: {
    src: string;
    alt: string;
    available: boolean;
  };
}

export const deviceImages: DeviceImageConfig = {
  // Laryngoscopes
  'Mac': {
    src: '/images/devices/macintosh-laryngoscope.jpg',
    alt: 'Macintosh Laryngoscope',
    available: false // Set to true when image is available
  },
  'Miller': {
    src: '/images/devices/miller-laryngoscope.jpg',
    alt: 'Miller Laryngoscope',
    available: false
  },
  'Parsons': {
    src: '/images/devices/parsons-laryngoscope.jpg',
    alt: 'Parsons Laryngoscope',
    available: false
  },
  'Lindholm': {
    src: '/images/devices/lindholm-laryngoscope.jpg',
    alt: 'Lindholm Laryngoscope',
    available: false
  },
  
  // Bronchoscopes
  'Bronchoscope (Storz)': {
    src: '/images/devices/storz-bronchoscope.jpg',
    alt: 'Storz Bronchoscope',
    available: false
  },
  
  // ETT
  'Portex Endotracheal Tube': {
    src: '/images/devices/portex-ett.jpg',
    alt: 'Portex Endotracheal Tube',
    available: false
  },
  
  // LMA
  'Laryngeal Mask': {
    src: '/images/devices/laryngeal-mask.jpg',
    alt: 'Laryngeal Mask Airway',
    available: false
  },
  
  // Tracheostomy
  'Shiley Cuffed': {
    src: '/images/devices/shiley-trach.jpg',
    alt: 'Shiley Cuffed Tracheostomy Tube',
    available: false
  },
  'Bivona Flextend TTS Cuffed': {
    src: '/images/devices/bivona-flextend.jpg',
    alt: 'Bivona Flextend TTS Cuffed',
    available: false
  },
  'Bivona Flextend PLUS TTS': {
    src: '/images/devices/bivona-flextend-plus.jpg',
    alt: 'Bivona Flextend PLUS TTS',
    available: false
  },
  'Bivona Hyperflex TTS': {
    src: '/images/devices/bivona-hyperflex.jpg',
    alt: 'Bivona Hyperflex TTS',
    available: false
  },
  'Tracoe Mini': {
    src: '/images/devices/tracoe-mini.jpg',
    alt: 'Tracoe Mini Tracheostomy Tube',
    available: false
  }
};

export const getDeviceImage = (manufacturer: string) => {
  return deviceImages[manufacturer] || null;
};